/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type SafetyDriverMatchingCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  lastVehicleInteraction: {
    __typename?: 'VehicleInteraction'
    timestamp: string
    type: Types.VehicleInteractionType
    reason: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      firstName: string
      lastName: string
    } | null
  } | null
}

export type SafetyDriverAssignedVehicleQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type SafetyDriverAssignedVehicleQuery = {
  __typename?: 'Query'
  safetyDriverAssignedVehicle: {
    __typename?: 'Vehicle'
    id: string
    label: number | null
  } | null
}

export type SafetyDriverMatchingCardMatchMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type SafetyDriverMatchingCardMatchMutation = {
  __typename?: 'Mutation'
  vehicleMatchSafetyDriver: {
    __typename?: 'VehicleMatchSafetyDriverResponse'
    vehicle: {
      __typename?: 'Vehicle'
      id: string
      lastVehicleInteraction: {
        __typename?: 'VehicleInteraction'
        timestamp: string
        type: Types.VehicleInteractionType
        reason: string | null
        backofficeUser: {
          __typename?: 'BackofficeUser'
          id: string
          firstName: string
          lastName: string
        } | null
      } | null
    }
  }
}

export type SafetyDriverMatchingCardUnmatchMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type SafetyDriverMatchingCardUnmatchMutation = {
  __typename?: 'Mutation'
  vehicleUnmatchSafetyDriver: {
    __typename?: 'VehicleUnmatchSafetyDriverResponse'
    vehicle: {
      __typename?: 'Vehicle'
      id: string
      lastVehicleInteraction: {
        __typename?: 'VehicleInteraction'
        timestamp: string
        type: Types.VehicleInteractionType
        reason: string | null
        backofficeUser: {
          __typename?: 'BackofficeUser'
          id: string
          firstName: string
          lastName: string
        } | null
      } | null
    }
  }
}

export const SafetyDriverMatchingCardVehicleFragmentDoc = gql`
    fragment SafetyDriverMatchingCardVehicle on Vehicle {
  id
  lastVehicleInteraction {
    timestamp
    type
    reason
    backofficeUser {
      id
      firstName
      lastName
    }
  }
}
    `
export const SafetyDriverAssignedVehicleDocument = gql`
    query SafetyDriverAssignedVehicle {
  safetyDriverAssignedVehicle {
    id
    label
  }
}
    `

/**
 * __useSafetyDriverAssignedVehicleQuery__
 *
 * To run a query within a React component, call `useSafetyDriverAssignedVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyDriverAssignedVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyDriverAssignedVehicleQuery({
 *   variables: {
 *   },
 * });
 */
export function useSafetyDriverAssignedVehicleQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SafetyDriverAssignedVehicleQuery,
    SafetyDriverAssignedVehicleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SafetyDriverAssignedVehicleQuery,
    SafetyDriverAssignedVehicleQueryVariables
  >(SafetyDriverAssignedVehicleDocument, options)
}
export function useSafetyDriverAssignedVehicleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SafetyDriverAssignedVehicleQuery,
    SafetyDriverAssignedVehicleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SafetyDriverAssignedVehicleQuery,
    SafetyDriverAssignedVehicleQueryVariables
  >(SafetyDriverAssignedVehicleDocument, options)
}
// @ts-ignore
export function useSafetyDriverAssignedVehicleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SafetyDriverAssignedVehicleQuery,
    SafetyDriverAssignedVehicleQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SafetyDriverAssignedVehicleQuery,
  SafetyDriverAssignedVehicleQueryVariables
>
export function useSafetyDriverAssignedVehicleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SafetyDriverAssignedVehicleQuery,
        SafetyDriverAssignedVehicleQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SafetyDriverAssignedVehicleQuery | undefined,
  SafetyDriverAssignedVehicleQueryVariables
>
export function useSafetyDriverAssignedVehicleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SafetyDriverAssignedVehicleQuery,
        SafetyDriverAssignedVehicleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SafetyDriverAssignedVehicleQuery,
    SafetyDriverAssignedVehicleQueryVariables
  >(SafetyDriverAssignedVehicleDocument, options)
}
export type SafetyDriverAssignedVehicleQueryHookResult = ReturnType<
  typeof useSafetyDriverAssignedVehicleQuery
>
export type SafetyDriverAssignedVehicleLazyQueryHookResult = ReturnType<
  typeof useSafetyDriverAssignedVehicleLazyQuery
>
export type SafetyDriverAssignedVehicleSuspenseQueryHookResult = ReturnType<
  typeof useSafetyDriverAssignedVehicleSuspenseQuery
>
export type SafetyDriverAssignedVehicleQueryResult = Apollo.QueryResult<
  SafetyDriverAssignedVehicleQuery,
  SafetyDriverAssignedVehicleQueryVariables
>
export const SafetyDriverMatchingCardMatchDocument = gql`
    mutation SafetyDriverMatchingCardMatch($vehicleId: ID!) {
  vehicleMatchSafetyDriver(input: {vehicleId: $vehicleId}) {
    vehicle {
      ...SafetyDriverMatchingCardVehicle
    }
  }
}
    ${SafetyDriverMatchingCardVehicleFragmentDoc}`
export type SafetyDriverMatchingCardMatchMutationFn = Apollo.MutationFunction<
  SafetyDriverMatchingCardMatchMutation,
  SafetyDriverMatchingCardMatchMutationVariables
>

/**
 * __useSafetyDriverMatchingCardMatchMutation__
 *
 * To run a mutation, you first call `useSafetyDriverMatchingCardMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSafetyDriverMatchingCardMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [safetyDriverMatchingCardMatchMutation, { data, loading, error }] = useSafetyDriverMatchingCardMatchMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useSafetyDriverMatchingCardMatchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SafetyDriverMatchingCardMatchMutation,
    SafetyDriverMatchingCardMatchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SafetyDriverMatchingCardMatchMutation,
    SafetyDriverMatchingCardMatchMutationVariables
  >(SafetyDriverMatchingCardMatchDocument, options)
}
export type SafetyDriverMatchingCardMatchMutationHookResult = ReturnType<
  typeof useSafetyDriverMatchingCardMatchMutation
>
export type SafetyDriverMatchingCardMatchMutationResult =
  Apollo.MutationResult<SafetyDriverMatchingCardMatchMutation>
export type SafetyDriverMatchingCardMatchMutationOptions =
  Apollo.BaseMutationOptions<
    SafetyDriverMatchingCardMatchMutation,
    SafetyDriverMatchingCardMatchMutationVariables
  >
export const SafetyDriverMatchingCardUnmatchDocument = gql`
    mutation SafetyDriverMatchingCardUnmatch($vehicleId: ID!) {
  vehicleUnmatchSafetyDriver(input: {vehicleId: $vehicleId}) {
    vehicle {
      ...SafetyDriverMatchingCardVehicle
    }
  }
}
    ${SafetyDriverMatchingCardVehicleFragmentDoc}`
export type SafetyDriverMatchingCardUnmatchMutationFn = Apollo.MutationFunction<
  SafetyDriverMatchingCardUnmatchMutation,
  SafetyDriverMatchingCardUnmatchMutationVariables
>

/**
 * __useSafetyDriverMatchingCardUnmatchMutation__
 *
 * To run a mutation, you first call `useSafetyDriverMatchingCardUnmatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSafetyDriverMatchingCardUnmatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [safetyDriverMatchingCardUnmatchMutation, { data, loading, error }] = useSafetyDriverMatchingCardUnmatchMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useSafetyDriverMatchingCardUnmatchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SafetyDriverMatchingCardUnmatchMutation,
    SafetyDriverMatchingCardUnmatchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SafetyDriverMatchingCardUnmatchMutation,
    SafetyDriverMatchingCardUnmatchMutationVariables
  >(SafetyDriverMatchingCardUnmatchDocument, options)
}
export type SafetyDriverMatchingCardUnmatchMutationHookResult = ReturnType<
  typeof useSafetyDriverMatchingCardUnmatchMutation
>
export type SafetyDriverMatchingCardUnmatchMutationResult =
  Apollo.MutationResult<SafetyDriverMatchingCardUnmatchMutation>
export type SafetyDriverMatchingCardUnmatchMutationOptions =
  Apollo.BaseMutationOptions<
    SafetyDriverMatchingCardUnmatchMutation,
    SafetyDriverMatchingCardUnmatchMutationVariables
  >
